import { AccountInterface, Call } from 'starknet';
import { InvokeResponse } from '../interfaces';
import { isSlippageError } from './parseTransactionError';

export async function executeTransaction(account: AccountInterface, calls: Call[]): Promise<InvokeResponse> {
  try {
    const response = await account.execute(calls, {
      maxFee: BigInt(1000000000000000),
    });

    return {
      transactionHash: response.transaction_hash,
    };
  } catch (error) {
    // Don't retry if the user rejected the transaction
    if (
      error instanceof Error &&
      error.message &&
      (error.message.includes('USER_REFUSED_OP') || error.message.includes('Signature failed'))
    ) {
      throw error;
    }

    // Don't retry slippage errors — they will fail again with the same stale quote
    if (isSlippageError(error)) {
      throw error;
    }

    const response = await account.execute(calls);

    return {
      transactionHash: response.transaction_hash,
    };
  }
}
